import {useCallback, useEffect, useState} from 'react';

import {referralService} from '@/services/referralService';
import type {AfriexReferralTier} from '@/types';
import {getErrorMessage} from '@/utils/errorMessage';
import {showErrorMessage} from '@/utils/showErrorMessage';

type TierDetailsReturnProps = {
  isLoading: boolean;
  tier: AfriexReferralTier;
};

const useTierDetails = (tierId: string): TierDetailsReturnProps => {
  const [isLoading, setIsLoading] = useState(true);
  const [tier, setTier] = useState<AfriexReferralTier>(
    {} as AfriexReferralTier,
  );
  const fetchTierDetails = useCallback(async (id: string) => {
    try {
      setIsLoading(true);
      const tierItem = await referralService.getTier(id);
      setTier(tierItem);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      showErrorMessage(
        'Tier details could not be fetched:' +
          getErrorMessage(err, String(err)),
      );
    }
  }, []);
  useEffect(() => {
    // Fire-and-forget: fetchTierDetails try/catches, clears `isLoading` and
    // reports through showErrorMessage, so this only stops an unexpected
    // throw becoming an unhandled rejection.
    fetchTierDetails(tierId).catch(() => {});
  }, [fetchTierDetails, tierId]);

  return {isLoading, tier};
};
export default useTierDetails;
